import { createContext } from 'react';
import type { User } from './User';

const AuthContext = createContext<{
  getAuthToken: () => Promise<string>;
  userAccount: User;
}>({
  getAuthToken: async () => {
    throw new Error('getAuthToken not initialized');
  },
  userAccount: {},
});

export default AuthContext;
